import React, { createContext, useContext,useEffect,useState } from "react";
import api from "./api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = async () => {
    try {
      const { data } = await api.get("/auth/me");

      setUser({
        id: data.id,
        email: data.email,
        role: data.role,
        name: data.name,
        isAuthenticated: true,
      });
    } catch (err) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    checkAuth();
  }, []);

  const login = async (email, password,remember) => {
    const { data } = await api.post("/admin/login", { email, password,remember });
    setUser({ email, isAuthenticated: true, role: data.role,name:data.name });
  };
  const studentLogin = async (email, password,remember) => {
    const { data } = await api.post("/student/login", { email, password,remember });
    setUser({ id:data.id,email, isAuthenticated: true, role: data.role,name:data.name });
  };
  const logout = async () => {
      await api.post('/admin/logout');

    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout,studentLogin,loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
